import { render, staticRenderFns } from "./PoljeUnosaDatum.vue?vue&type=template&id=2a1d5168&scoped=true"
import script from "./PoljeUnosaDatum.vue?vue&type=script&lang=js"
export * from "./PoljeUnosaDatum.vue?vue&type=script&lang=js"
import style0 from "./PoljeUnosaDatum.vue?vue&type=style&index=0&id=2a1d5168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1d5168",
  null
  
)

export default component.exports